//#region 
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { PropTypes } from 'prop-types'
import { useDispatch, useSelector } from 'react-redux';
import { Action_LoginsOpener, Action_toggleSideMenu } from '../store/action/Action-ALL';
import { Card, CardHeader } from '@material-ui/core';
import UserAccountAvatar from './hooks/UserAccountAvatar';
import history from './hooks/history';
import StorageIcon from '@material-ui/icons/Storage';
import LibraryAddSharpIcon from '@material-ui/icons/LibraryAddSharp';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import InfoSharpIcon from '@material-ui/icons/InfoSharp';
import ExitToAppSharpIcon from '@material-ui/icons/ExitToAppSharp';
//#endregion

const useStyles = makeStyles((theme) => ({
  // list: {
  //   width: 270,
  // },
  paper: {
    width: 260,
    paddingBottom: 35,
  },
  fullList: {
    width: 'auto',
  },

  // avatar: {
  //   backgroundColor: red[500],
  // },
  cartDrawer: {
    backgroundImage: 'url("/appImgs/drawerBG2-min.jpg")',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    marginBottom: '4rem',
    // height: '40%',
  },
  cartHeaderDrawer: {
    marginTop: '7rem',
    color: '#1010cc',
    alignItems: 'flex-end'
    // letterSpacing: "5px", fontWeight: 400, fontSize: "1rem"    
  },
  menuHeader: {
    ...theme.typography.button,
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(1),
    textAlign: 'center',
  },
  menuDivider: {
    margin: '2rem',
  }

}));

export default function SideMenuDrawer() {

  const { user } = useSelector(state => state.reducer_user)
  const classes = useStyles();
  const { isMenuOpen } = useSelector(state => state.reducer_ALL)
  const dispatch = useDispatch()



  const toggleDrawer = () => (event) => {

    // console.log('event:', event)

    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    dispatch(Action_toggleSideMenu())
  };


  const list = () => (
    <div
      role="presentation"
      onClick={toggleDrawer()}
      onKeyDown={toggleDrawer()}
    >

      <Card className={classes.cartDrawer}>
        <CardHeader className={classes.cartHeaderDrawer} 
          avatar={
            <UserAccountAvatar />
          }
          titleTypographyProps={{variant:'h6' }}
          title={user?.name || 'anonymous user'}
          subheader={user?.email || ''}
        />

        <CardHeader />
      </Card>

      <div className={classes.menuHeader} >Costumer</div>
      <List>

        <ListItem button
          onClick={() => dispatch(Action_LoginsOpener(true))} >
          <ListItemIcon><ExitToAppSharpIcon /></ListItemIcon>
          <ListItemText primary='Log-In' />
        </ListItem>

        <ListItem button
          onClick={() => history.push('/UserOrdersScreen')} >
          <ListItemIcon><StorageIcon /></ListItemIcon>
          <ListItemText primary='My Orders' />
        </ListItem>

        <ListItem button
          onClick={() => history.push('/About')} >
          <ListItemIcon><InfoSharpIcon /></ListItemIcon>
          <ListItemText primary='About' />
        </ListItem>

      </List>
      <Divider className={classes.menuDivider} />
      <div className={classes.menuHeader} >Seller</div>


      <List>
        <ListItem button
          onClick={() => history.push('/seller/NewProductScreen')} >
          <ListItemIcon><LibraryAddSharpIcon /></ListItemIcon>
          <ListItemText primary='New Product' />
        </ListItem>

      </List>

      <Divider className={classes.menuDivider} />
      <div className={classes.menuHeader} >Admin</div>


      <List>
        <ListItem button
          onClick={() => history.push('/admin/UsersManagementScreen')} >
          <ListItemIcon><SupervisorAccountIcon /></ListItemIcon>
          <ListItemText primary='Users Management' />
        </ListItem>

      </List>


    </div>
  );

  return (
    <SwipeableDrawer
      classes={{ paper: classes.paper }}
      open={isMenuOpen['left']}
      onClose={toggleDrawer()}
      onOpen={toggleDrawer()}
    >
      {list()}
    </SwipeableDrawer>
  );
}

SideMenuDrawer.propTypes = {
  isAppSideMenuOpen: PropTypes.bool,
}